import React from 'react';

const SilentRenew = () => {
  return <div>Loading...</div>;
};

export default SilentRenew;
